import RefreshIcon from "@mui/icons-material/Refresh";
import { Alert, Box, CircularProgress, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useProtectionZoneSummary } from "../../../hooks/ManagementUnit/useProtectionZoneSummary";
import { ProtectionZoneSummary } from "../../Captures/ProtectionZone/ProtectionZoneSummary";

interface ProtectionZoneTabProps {
  managementUnitId?: string;
  handleError?: any;
}

const ProtectionZoneTab: React.FC<ProtectionZoneTabProps> = ({ managementUnitId, handleError }) => {
  const { t } = useTranslation();
  const { protectionZoneSummaryData, isPending, isError, error, refetch } = useProtectionZoneSummary(managementUnitId);

  useEffect(() => {
    if (!handleError) return;
    if (isError) handleError(error);
  }, [isError]);

  if (isPending && !protectionZoneSummaryData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError && !protectionZoneSummaryData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Alert
          severity="error"
          action={
            <IconButton onClick={() => refetch()} color="inherit" size="small">
              <RefreshIcon />
            </IconButton>
          }
        >
          {t("generic.errors.something-went-wrong")}
        </Alert>
      </Box>
    );
  }

  if (!protectionZoneSummaryData) return null;

  return (
    <ProtectionZoneSummary
      protectionZoneSummaryData={protectionZoneSummaryData}
    />
  );
};

export default ProtectionZoneTab;
